import { createContext } from 'react';
const defaultI18n = {
    t: () => null,
};
const defaultSmartKeyContextValue = {
    i18n: defaultI18n,
    a11y: defaultI18n,
    isDev: false,
};
const SmartKeyContext = createContext(defaultSmartKeyContextValue);
export const SmartKeyProvider = SmartKeyContext.Provider;
export const SmartKeyConsumer = SmartKeyContext.Consumer;
